module.exports = __webpack_public_path__ + "static/media/img_cover01.cb8d33b0.png";